import React, { createContext, useContext, useState } from 'react';

import type { Context } from '../hooks/useDownloadFlyerModalBody/types';
import { FlyerDownloadModal } from '../index';

type FlyerDownloadModalContextType = {
	openModal: (context: Context) => void;
	closeModal: () => void;
};

const FlyerDownloadModalContext = createContext<FlyerDownloadModalContextType>({
	openModal: (_context: Context) => {},
	closeModal: () => {},
});

export const useFlyerDownloadModalContext = () => useContext(FlyerDownloadModalContext);

export const FlyerDownloadModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [context, setContext] = useState<Context>('starter_dashboard_grow_petition');

	const openModal = (_context: Context) => {
		setIsOpen(true);
		setContext(_context);
	};

	const closeModal = () => {
		setIsOpen(false);
	};

	return (
		<FlyerDownloadModalContext.Provider value={{ openModal, closeModal }}>
			{children}
			<FlyerDownloadModal isOpen={isOpen} context={context} onClose={closeModal} />
		</FlyerDownloadModalContext.Provider>
	);
};
